import { Component, OnInit,AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridOptions } from 'ag-grid-community';
import { AlertService, AuthenticationService, UserService } from '../_services';
import * as moment from 'moment';
import { DatepickerOptions } from 'ng2-datepicker';
import * as frLocale from 'date-fns/locale/en';
import { ChildCommentRenderer } from '../allocatecallhistory/cellRenderer';
@Component({
  selector: 'app-allocatehistory',
  templateUrl: './allocatehistory.component.html',
  styleUrls: ['./allocatehistory.component.scss']
})
export class AllocatehistoryComponent implements OnInit,AfterViewInit {
  searchForm: FormGroup;
  private gridOptions: GridOptions;
  private context;
  private gridApi;
  private gridColumnApi;
  private rowSelection;
  private colResizeDefault;
  private domLayout;
  // private defaultColDef;
  public tempGridList: any = [];
  private lastindexofgrid: number = 0;
  private totalrawcount: number = 0;  
  private isFromDns:string="";
  private userID: string = "";
  private frameworkComponents;
  private isgraybackground:boolean=false;
  private rowHeight;
  private CommentContent:string="";
  private TaskList:any=[];
  private DirectionList:any=[];
   //datetime formate
   fromoptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    //minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {},
    fieldId:'searchFromDate', // Optional, value to pass to [ngStyle] on the input field
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  tooptions: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2099,
    displayFormat: 'YYYY-MM-DD',
    barTitleFormat: 'YYYY-MM-DD',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0,
    locale: frLocale,
    minDate: new Date(Date.now()), // Minimal selectable date
    //maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'YYYY-MM-DD',
    placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'searchtoDate',
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };
  defaultColDef = { resizable: true ,autoHeight:true};
   //Device DropDown 
  //  selectdeviceoption= [
  //   {"key":"","value":"Device"},
  //   {"key":"LANDLINE","value":"LANDLINE"},
  //   {"key":"MOBILE","value":"MOBILE"},
  //  ];
   selecttaskkey="value";
  
   //Direction DropDown 
   selectdirectionoption= [
    {"key":"","value":"Direction"},
    {"key":"INCOMING","value":"INCOMING"},
    {"key":"OUTGOING","value":"OUTGOING"},
   ];
   selectdirectionkey="value";

   //Extention Dropdown 
   selectextkey="value";
   //DropDown Style Class
   styleGuide: {
    caretClass: 'caret',
    selectBoxClass: 'dropdown-wrapper',
    selectMenuClass: 'dropdown',
    optionsClass: 'option' 
   }
  constructor(private formBuilder: FormBuilder,private userservice:UserService,private alertService: AlertService) {

    this.searchForm = this.formBuilder.group({
      searchPhoneNumber: [''],
      searchDirection: [{"key":"","value":"Direction"}],
      searchDevice: [{"key":"","value":"Task"}],
      searchExt: [{"key":"","value":"Ext"}],
      searchFromDate: [''],
      searchToDate: ['']
      //password: ['', [Validators.required,Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
    });

    this.context = { componentParent: this };
    this.frameworkComponents = {
      childCommentRenderer: ChildCommentRenderer
    };
   }

  ngOnInit() {
    if(localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor"))
    {
      //this.isFromDns=localStorage.getItem("isfromDns")
      this.isgraybackground=true;
    }
    this.userID = localStorage.getItem("user");
    this.gridOptions = <GridOptions>{};
    this.createParentColumnDefs();
    
    this.getdata();
   
  this.getdirection();
  this.getdevice();
  }

  getdevice(){
    this.TaskList = [];
    this.TaskList.push({ "key": "Mobile Call", "value": "Mobile Call" })
    this.TaskList.push({ "key": "Word", "value": "Word" })
    this.TaskList.push({ "key": "Excel", "value": "Excel" })
    this.TaskList.push({ "key": "Email", "value": "Email" })
    this.TaskList.push({ "key": "Whatsapp", "value": "Whatsapp" })
    this.TaskList.push({ "key": "Other", "value": "Other" })
    // this.userservice.DeviceList(localStorage.getItem('ServerId')).subscribe(
    //   response => {
    //     this.TaskList = [{ "key": "", "value": "Device" }];

    //     let data = response;
    //     if (data["StatusCode"] == "200") {
    //       let DeviceData = data["Data"];

    //       if (DeviceData.length > 0) {
    //        DeviceData.forEach((value, key, i) => {
    //         this.TaskList.push({ "key": value.trim(), "value": value.trim() })
    //       });
    //       }
    //     }
    //   });
  }

  getdirection(){
    
    this.userservice.DirectionList(localStorage.getItem('ServerId')).subscribe(
      response => {
        debugger;
        let data = response;
        this.DirectionList=[{ "key": "", "value": "Direction" }];
        if (data["StatusCode"] == "200") {
          let DirectionData = data["Data"];

          if (DirectionData.length > 0) {
            DirectionData.forEach((value, key, i) => {
              this.DirectionList.push({ "key": value.trim(), "value": value.trim() })
            });
          
          }
         
        }
      });
  }
  SearchCallSubmit() {
    this.lastindexofgrid=0;
    this.getdata();
  }

  ResetFilter() {
    this.searchForm = this.formBuilder.group({
      searchPhoneNumber: [''],
      searchDirection: [{"key":"","value":"Direction"}],
      searchDevice: [{"key":"","value":"Task"}],
      searchExt: [{"key":"","value":"Ext"}],
      searchFromDate: [''],
      searchToDate: ['']

      //password: ['', [Validators.required,Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
    });
    this.lastindexofgrid = 0;
    let ele = (<HTMLInputElement>document.getElementById('searchFromDate'));
    ele.value= "";
    let ele2 = (<HTMLInputElement>document.getElementById('searchtoDate'));
    ele2.value= "";
    this.getdata();
  }
  tochange(event) {

    if(this.f.searchToDate.value!="")
    {
    let ele = (<HTMLInputElement>document.getElementById('searchtoDate'));
    ele.value= moment(this.f.searchToDate.value).format("YYYY-MM-DD");
    }
  }
// convenience getter for easy access to form fields
get f() { return this.searchForm.controls; }
  //from date change event
  fromchange(event) 
  {

    this.tooptions={
                  minYear: 1970,
                  maxYear: 2099,
                  displayFormat: 'YYYY-MM-DD',
                  barTitleFormat: 'YYYY-MM-DD',
                  dayNamesFormat: 'dd',
                  firstCalendarDay: 0,
                  locale: frLocale,
                  minDate:this.f.searchFromDate.value,
                  barTitleIfEmpty: 'YYYY-MM-DD',
                  placeholder: 'YYYY-MM-DD', // HTML input placeholder attribute (default: '')
                  addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
                  addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
                  fieldId: 'searchtoDate',
                  useEmptyBarTitle: false,
                  }
                  if(this.f.searchFromDate.value!="")
    {
    let ele = (<HTMLInputElement>document.getElementById('searchFromDate'));
    ele.value= moment(this.f.searchFromDate.value).format("YYYY-MM-DD");
    }
  }

  createParentColumnDefs() {
    this.gridOptions.columnDefs = [

      {
        headerName: "Date & Time",
        field: "RecordDate",
        width: 140,
        cellRenderer: (data) => {
          return moment(data.value).format('YYYY-MM-DD HH:mm')
        },
        suppressSizeToFit: true
      },
      {
        headerName: "Direction",
        field: "Direction",
        width: 90
      },
      {
        headerName: "Task Type",
        field: "RecordType",
        width: 90
      },
      // {
      //   headerName: "Ext",
      //   field: "Extension",
      //   width: 80
      // },
      // {
      //   headerName: "Phone Number",
      //   field: "PhoneNumber",
      //   width: 120
      // },
      {
        headerName: "Duration",
        field: "Duration",
        width: 90
      },
      // {
      //   headerName: "Previously Acct",
      //   field: "AccountName",
      //   width: 140
      // },
      {
        headerName: "Matter Code",
        field: "Account",
        width: 140
      },
      {
        headerName: "Rate",
        field: "Rate",
        width: 80
      },
      {
        headerName: "Total",
        field: "TotalCost",
        width: 80
      },
      {
        headerName: "Comment",
        cellRenderer: 'childCommentRenderer',
        colId: "params",
        field: "Action",
        cellStyle: { "white-space": "normal" },
       //field: "Comment",
        width: 190
      }
    ];
    //this.rowSelection = "multiple";
    this.colResizeDefault = "shift";
    this.domLayout = "autoHeight";
    
  }
  onColumnResized() {
    this.gridApi.resetRowHeights();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setGridAutoHeight(true)
    params.api.sizeColumnsToFit();
  }
  getdata() {
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.tempGridList = [];
    this.userservice.GetAllotedHistoryLog(25, this.lastindexofgrid, this.userID, this.f.searchPhoneNumber.value, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
      response => {
        let data = response;
        debugger;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];

          this.tempGridList = CallList["Call"];
          this.totalrawcount = CallList["CallCount"];
          if (this.tempGridList.length > 0) {
            this.lastindexofgrid = this.tempGridList.length;
          }

          this.gridOptions.api.setRowData(this.tempGridList);
        } else {
          this.gridOptions.api.setRowData(this.tempGridList);
          this.lastindexofgrid = 0;
          this.totalrawcount = 0;
        }

       

      },
      error => {
        this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }

  
  LoadMoreData() {
    this.gridOptions.api.showLoadingOverlay();
    let fromdate: string = "";
    let todate: string = "";
    if (this.f.searchFromDate.value != "") {
      fromdate = moment(this.f.searchFromDate.value).format();
    }
    if (this.f.searchToDate.value != "") {
      todate = moment(this.f.searchToDate.value).format();
    }
    this.userservice.GetallotedCallLog(25, this.lastindexofgrid, this.userID, this.f.searchPhoneNumber.value, this.f.searchDirection.value.key, this.f.searchDevice.value.key, this.f.searchExt.value.key, fromdate, todate).subscribe(
      response => {
        let data = response;
        debugger;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];
          this.totalrawcount = CallList["CallCount"];
          CallList["Call"].forEach((value, key, i) => {
            this.tempGridList.push(value)

          });
          if (this.tempGridList.length > 0) {
            this.lastindexofgrid = this.tempGridList.length;
          }

          this.gridOptions.api.setRowData(this.tempGridList);
          this.gridOptions.api.hideOverlay();
        }
        else {
          this.gridOptions.api.hideOverlay();
        }


      },
      error => {
        this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }
  // RefreshGridHeight()
  // {
    
  //    this.onColumnResized();
  //   //this.resizeWind()
  // }
  // private resizeWind(){
  //   this.gridOptions.api.forEachNode(rowNode => {
  //     if (rowNode.data) {
  //       rowNode.setRowHeight(100);
  //     }
  //   });
  //   this.gridOptions.api.onRowHeightChanged();
  // }
  ExpandComment(cell)
  {
    this.CommentContent="";
    if(cell.Comment){
      this.CommentContent=cell.Comment;
      document.getElementById("btncommentmodelpopup").click();
    }
  }
   ngAfterViewInit() {
  //   setTimeout(() => {

  //     this.defaultColDef = { resizable: true,autoHeight:true };
  //   });

   }
}
